import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './components/App';
import i18n from './i18n';

const INVALID_EMAIL = i18n.t('email-invalid');

// App script in page will provide the id to mount.
// Taken from https://stackoverflow.com/questions/53562804/how-to-include-the-same-react-app-twice-on-the-same-page
window.mountWebsiteSubscriptionSignup = function (id) {

  const initParams = {};

  const element = document.getElementById(id);

  const windowAppId = `${process.env.REACT_APP_WINDOW_APP_ID}` ? `${process.env.REACT_APP_WINDOW_APP_ID}` : 'portfolioMapper';

  initParams.wtRegion = window[windowAppId] && `${window[windowAppId].wtRegion}` && `${window[windowAppId].wtRegion}` !== 'undefined' ? `${window[windowAppId].wtRegion}` : "US";
  initParams.entityCCY = window[windowAppId] && `${window[windowAppId].entityCCY}` && `${window[windowAppId].entityCCY}` !== 'undefined' ? `${window[windowAppId].entityCCY}` : "USD";
  initParams.tenant = window[windowAppId] && `${window[windowAppId].tenant}` && `${window[windowAppId].tenant}` !== 'undefined' ? `${window[windowAppId].tenant}` : "wisdomtree";
  initParams.token = window[windowAppId] && `${window[windowAppId].token}` && `${window[windowAppId].token}` !== 'undefined' ? `${window[windowAppId].token}` : null;

  // Set up isoCode - first from the window param, then from the URL if not there
  initParams.isoCode = window[windowAppId] && `${window[windowAppId].isoCode}` && `${window[windowAppId].isoCode}` !== 'undefined' ?
    `${window[windowAppId].isoCode}` : "en-US";

  initParams.email = window[windowAppId] && `${window[windowAppId].clientEmail}` && `${window[windowAppId].clientEmail}` !== 'undefined' ? `${window[windowAppId].clientEmail}` : INVALID_EMAIL;

  // Check that we either have email/token or email/contactId to enable to app to work
  if (initParams.email !== INVALID_EMAIL && initParams.token) {
    initParams.paramsValid = true;
  } else {
    initParams.paramsValid = false;
  }

  initParams.dataspanApiUrl = `${process.env.REACT_APP_API_URL}`;
  initParams.dpdApiUrl = `${process.env.REACT_APP_DPD_URL}`;
  initParams.version = `${process.env.REACT_APP_VERSION}` !== 'undefined' ? `${process.env.REACT_APP_VERSION}` : 'DEV';

  // Change the language to that specified in the page.
  i18n.changeLanguage(initParams.isoCode);

  // // Get the custom Object ID of the subscription table (not category table) - 155 id the US default
  // initParams.subscriptionObjectId = element.dataset.subscriptionobjectid ? element.dataset.subscriptionobjectid : '155';

  // Get the subscription name to sign up for
  initParams.sfSubscription = element.dataset.sfsubscription ? element.dataset.sfsubscription : null;

  // Get the signup success message
  initParams.signupSuccess = element.dataset.signupsuccess ? element.dataset.signupsuccess : i18n.t('signup-success');

  // Get the signup already message
  initParams.signupAlready = element.dataset.signupalready ? element.dataset.signupalready : i18n.t('already-signed-up');

  // Get a checked value to look for in existing subscription
  initParams.checkedValue = element.dataset.checkedvalue ? element.dataset.checkedvalue : '1';

  // Store the param for the on color of the slider. Defaults to WT Teal
  initParams.checkColorOn = element.dataset.checkcoloron ? element.dataset.checkcoloron : '#05a9b1';

  // Store the param for the off color of the slider. Defaults to WT Gray
  initParams.checkColorOff = element.dataset.checkcoloroff ? element.dataset.checkcoloroff : '#5b6770';

  // Store the lead source description for the signup
  initParams.leadSourceDescription = element.dataset.leadsourcedescription ? element.dataset.leadsourcedescription : 'Website Registration';

  console.log('InitParams: ', initParams);

  // Deep copy the params to remove issues with multi apps and Redux
  const paramsCopy = JSON.parse(JSON.stringify(initParams));

  // render
  ReactDOM.render((
    <BrowserRouter>
      <App
        params={paramsCopy}
        dataProps={element.dataset}
      />
    </BrowserRouter>
  ), element);

}
